import { Component, Input } from '@angular/core';

@Component({
    selector: 'direction',
    template: `
        <span
            class="label label-direction"
            *ngIf="direction === 'EXIT' || direction === 'BUNDLE'"
        >
            EXIT </span
        ><span
            class="label label-direction"
            *ngIf="direction === 'ENTRY' || direction === 'BUNDLE'"
        >
            ENTRY
        </span>
    `
})
export class DirectionComponent {
    @Input() public direction: Direction;
}
